__turbopack_context__.v({
  "action": "AppSpotlight-module__8tGq2W__action",
});
